var React = require('react');

function NonProfits (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.0828 12.2631C17.0898 9.24557 12.2305 9.24566 9.23762 12.2632C6.25417 15.2711 6.25408 20.1407 9.23762 23.1487L23.9679 38L38.8082 23.0377C41.7306 20.0909 41.7306 15.3208 38.8082 12.3742C35.8758 9.41799 31.1155 9.41799 28.1835 12.3742L24.6274 15.9597L24.1882 16.4024L23.749 15.9597L20.0828 12.2631ZM20.0828 12.2631L20.522 11.7959","stroke":"#E0E7F6","strokeWidth":"1.5"}));
}

NonProfits.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = NonProfits;

NonProfits.default = NonProfits;
